import { ENVIRONMENTS } from 'constants-activate';

/**
 * Environment detection utilities shared across client and server
 */

/**
 * Detects if code is running in a browser environment
 */
export const isBrowser = typeof window !== 'undefined';

/**
 * Detects if code is running in a Node.js environment
 */
export const isNode =
  Object.prototype.toString.call(
    typeof process !== 'undefined' ? process : 0
  ) === '[object process]';

/**
 * Detects if code is running in a React Native environment
 */
export const isReactNative = global?.navigator?.product === 'ReactNative';

/**
 * Gets the current application environment
 * @deprecated Use libs/constants and APP_ENV injection instead
 */
export const getEnv = (): ENVIRONMENTS => {
  const { APP_ENV } = process.env;
  
  return Object.values(ENVIRONMENTS).find(e => e === APP_ENV) ?? ENVIRONMENTS.LOCAL;
};

/**
 * Legacy export for backward compatibility
 * @deprecated Use named exports instead
 */
const env = getEnv();
export default env;
